import { createSlice } from "@reduxjs/toolkit";
const initialValue = {
  searchedKeyword: undefined,
  brandKeyword: undefined,
  list: [],
};

const AllListing = createSlice({
  name: "allListing",
  initialState: initialValue,
  reducers: {
    setAllCarListing: (state, action) => {
      return {
        ...state,
        list: [...action.payload],
      };
    },
    addSearchingKeyword: (state, action) => {
      return { ...state, searchedKeyword: action.payload };
    },
    removeSearchingKeyword: (state, action) => {
      return { ...state, searchedKeyword: undefined };
    },
    addBrandKeyword: (state, action) => {
      return { ...state, brandKeyword: action.payload };
    },
    removeBrandKeyword: (state, action) => {
      return { ...state, brandKeyword: undefined };
    },
  },
});

const { reducer } = AllListing;
export default reducer;
export const {
  setAllCarListing,
  addSearchingKeyword,
  removeSearchingKeyword,
  addBrandKeyword,
  removeBrandKeyword,
} = AllListing.actions;
